import { connect } from 'react-redux';
import { isSpinning } from '../spinner';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class IsSpinning extends Component {
    static propTypes = {
        children: PropTypes.node,
        component: PropTypes.node.isRequired,
        id: PropTypes.string.isRequired,
        spinners: ImmutablePropTypes.map.isRequired,
    }

    static defaultProps = {
        component: 'div',
    }

    render() {
        /*eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }]*/
        const { id, spinners, component, children, dispatch, ...props } = this.props;

        if (!spinners || !isSpinning(spinners, id)) {
            return null;
        }
        if (children.length === 1) {
            return children;
        }

        return children.length === 1
            ? children
            : React.createElement(component, props, children);
    }
}

export default connect((state) => ({
    spinners: state.spinner,
}))(IsSpinning);
